import axios, { Axios } from "axios";
import { baseApiV2_1 } from "../../constants/Presets";

export function FetchDataPointList(payload) {
  const url = `${baseApiV2_1}dictionaries/datapoints/list?`;
  const params = [];
  // const { dataPointId } = payload;
  // params.push(`dataPointId=${dataPointId}`);
  const group = payload.group || "";
  params.push(`group=${group}`);
  const order = payload.order || "DESC";
  params.push(`order=${order}`);
  const order_By = payload.order_By || "";
  params.push(`order_by=${order_By}`);
  if (payload.query) {
    const { query } = payload;
    params.push(`query=${encodeURIComponent(query).toString()}`);
  }
  const page = payload.page || 0;
  params.push(`page=${page}`);
  const size = payload.size || "";
  params.push(`size=${size}`);
  const filters = payload.filters
    ? encodeURIComponent(JSON.stringify(payload.filters))
    : null;
  if (filters) {
    params.push(`filters=${filters}`);
  }
  params.push("initial_load=true");
  const paramStr = params.join("&");
  return axios.get(url + paramStr);
}
